import React from 'react'

import BlockComponentSelector from '../BlockComponentSelector'
import { contentAreaDataMapper } from 'Helpers/transform'

const ContentArea = ({ data, name, inEditMode }) => {
  if (!data) {
    if (!inEditMode) return null
    return (
      <div data-epi-edit={name} className="col-span-12 row-span-6">
        Click to edit
      </div>
    )
  }

  const blockData = contentAreaDataMapper(data)
  const validContentAreaItems = Array.isArray(data)
    ? data.filter((contentAreaItem) => contentAreaItem?.ContentLink?.Id)
    : []

  return (
    <div data-epi-edit={name}>
      {validContentAreaItems.map((contentAreaItem, index) => {
        const contentLinkId = contentAreaItem.ContentLink.Id
        return (
          <div data-epi-block-id={contentLinkId} key={`${contentLinkId}-${index}`}>
            <BlockComponentSelector data={blockData[contentLinkId]} />
          </div>
        )
      })}
    </div>
  )
}

export default React.memo(ContentArea)
